
import React, { useEffect, useState } from "react";
import "./Left_Tabs.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import "swiper/css";
import "swiper/css/pagination";
import { Dropdown } from "react-bootstrap";
import Logout_Modal from "../../common-components/common_modal/logout_modal/Logout_Modal";

const Left_Tabs = (props) => {
  const [showLogoutModal, setshowLogoutModal] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [activeSubTab, setActiveSubTab] = useState(null);
  const [expandedTabIndex, setExpandedTabIndex] = useState(null);

  const mobile_tabs = [
    {
      tab_label: "PERSONAL INFORMATION",
    },
    {
      tab_label: "ORDERED",
    },
    {
      tab_label: "DELIVERED",
    },
    {
      tab_label: "RETURN",
    },
    {
      tab_label: "REPLACE",
    },
    {
      tab_label: "CANCELLED",
    },
    {
      tab_label: "MANAGE ADDRESS",
    },
    // {
    //   tab_label: "CHANGE PASSWORD",
    // },
    {
      tab_label: "LOGOUT",
    },
  ];

  const tabs = [
    {
      tab_label: "PERSONAL INFORMATION",
    },
    {
      tab_label: "MY ORDERS",
      subTabs: ["Ordered", "Delivered", "Return", "Replace", "Cancelled"],
    },
    {
      tab_label: "MANAGE ADDRESS",
    },
    // {
    //   tab_label: "CHANGE PASSWORD",
    // },
    {
      tab_label: "LOGOUT",
    },
  ];

  useEffect(() => {
    const ordersTabIndex = tabs.findIndex(
      (tab) => tab.tab_label === "MY ORDERS",
    );

    const ordersTab = tabs[ordersTabIndex];

    if (
      activeTab === ordersTabIndex &&
      ordersTab?.subTabs?.length > 0 &&
      !activeSubTab
    ) {
      const defaultSubTab = ordersTab.subTabs[0];

      setActiveSubTab(defaultSubTab);
      props?.setSelectedTab(defaultSubTab);
    }
  }, [activeTab]);

  const handleMainTabClick = (item, index) => {
    // Logout
    if (item?.tab_label === "LOGOUT") {
      setshowLogoutModal(true);
      return;
    }

    const hasSubTabs = item?.subTabs?.length > 0;

    // MY ORDERS
    if (hasSubTabs) {
      setActiveTab(index);

      // Toggle dropdown only when MY ORDERS is clicked
      setExpandedTabIndex((prev) => {
        if (prev === index) {
          return null;
        }

        return index;
      });

      // If no sub-tab is selected, select the first one
      if (!activeSubTab || !item.subTabs.includes(activeSubTab)) {
        const defaultSubTab = item.subTabs[0];

        setActiveSubTab(defaultSubTab);
        props?.setSelectedTab(defaultSubTab);
      }

      return;
    }

    // Normal tabs
    setActiveTab(index);
    setActiveSubTab(null);
    setExpandedTabIndex(null);
    props?.setSelectedTab(item?.tab_label);
  };

  const handleSubTabClick = (subTab) => {
    setActiveSubTab(subTab);
    props?.setSelectedTab(subTab);

    // Do NOT close MY ORDERS dropdown
    // Dropdown will only close when MY ORDERS is clicked
  };

  return (
    <section className="Left_Tabs">
      {/* DESKTOP */}
      <div className="desktop_sidebar">
        {tabs.map((item, index) => {
          const isMainActive = activeTab === index;
          const hasSubTabs = item?.subTabs?.length > 0;
          const isExpanded = expandedTabIndex === index;

          return (
            <React.Fragment key={index}>
              <div
                className={`tabs_main_div ${
                  isMainActive ? "active red_bg_div" : "blue_bg_div"
                }`}
                onClick={() => handleMainTabClick(item, index)}
              >
                <div className="text_holder">
                  <p className="tab_name">{item?.tab_label}</p>

                  {hasSubTabs && (
                    <span className="icon">
                      {isExpanded ? (
                        <FontAwesomeIcon icon={faAngleUp} />
                      ) : (
                        <FontAwesomeIcon icon={faAngleDown} />
                      )}
                    </span>
                  )}
                </div>
              </div>

              {/* MY ORDERS DROPDOWN */}
              {hasSubTabs && isExpanded && (
                <div className="inner_tabs">
                  {item.subTabs.map((subTab, subIndex) => (
                    <div
                      key={subIndex}
                      className={`inner_tab ${
                        activeSubTab === subTab
                          ? "active-sub-tab"
                          : "blue_bg_div"
                      }`}
                      onClick={() => handleSubTabClick(subTab)}
                    >
                      {subTab}
                    </div>
                  ))}
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      {/* MOBILE */}
      <div className="mobile_div">
        <Dropdown>
          <Dropdown.Toggle
            className="tabs_main_div active dropdown_button"
            id="tab-dropdown"
          >
            <div className="text_holder">
              <p className="tab_name">
                {mobile_tabs[activeTab]?.tab_label || "Select Tab"}
              </p>
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {mobile_tabs.map((value, index) => {
              const isMainActive = activeTab === index;

              return (
                <Dropdown.Item key={index}>
                  <div
                    className={`tabs_main_div ${
                      isMainActive ? "active red_bg_div" : "blue_bg_div"
                    }`}
                    onClick={() => {
                      if (value?.tab_label === "LOGOUT") {
                        setshowLogoutModal(true);
                        return;
                      }

                      setActiveTab(index);
                      props?.setSelectedTab(value?.tab_label);
                    }}
                  >
                    <div className="text_holder">
                      <p className="tab_name">{value?.tab_label}</p>
                    </div>
                  </div>
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <Logout_Modal
        show={showLogoutModal}
        onHide={() => setshowLogoutModal(false)}
      />
    </section>
  );
};

export default Left_Tabs;